(() => {
  const root = document.getElementById('MainContent');
  if (!root || root.dataset.dsAddiPriceSync === 'true') return;
  root.dataset.dsAddiPriceSync = 'true';
  let frame = null;
  const sync = () => {
    frame = null;
    const priceElement = root.querySelector('.main-product [id^="price-"] [data-ds-addi-price]');
    const widget = root.querySelector('addi-product-widget');
    if (!priceElement || !widget) return;
    const price = Number(priceElement.dataset.dsAddiPrice);
    if (!Number.isFinite(price) || price <= 0) return;
    const value = String(price);
    if (widget.getAttribute('price') !== value) widget.setAttribute('price', value);
  };
  const schedule = () => {
    if (frame === null) frame = requestAnimationFrame(sync);
  };
  new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
  window.addEventListener('pageshow', schedule);
  schedule();
})();
